import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import appointmentService from "../../services/appointmentService";
import litigantMenuActions from "../../actions/litigantMenuActions";
import alertActions from "../../actions/alertActions";

const RequestAppointmentModal = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const dispatch = useDispatch();

  const requestAppointment = () => {
    appointmentService.userRequestAppointment().then(() => {
      dispatch(alertActions.success("Request for appointment submitted."));
      dispatch(litigantMenuActions.getLitigantMenuOptions());
      toggle();
    });
  };
  return (
    <div className="mt-auto">
      <Button onClick={toggle} color="danger">
        Request an appointment
      </Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Request appointment!</ModalHeader>
        <ModalBody>
          Make sure you are satisfied with the responses in your questionnaire
          before confirming.
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={requestAppointment}>
            Request Appointment!
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default RequestAppointmentModal;
